<template>
    <div class="search-filter">
        <z-date-picker
            ref="datepicker"
            size="m"
            :placeholder="text.date"
            range
            is-filter
            @change="onDateChange"
            v-model="period"
        />
    </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { text } from '../locales'

const props = defineProps({
    data: {
        type: Object
    },
    initialParams: {
        type: Object,
        default: () => {}
    }
})

const params = ref({
    from: '',
    to: '',
})

const period = ref([])

const emit = defineEmits([
    'change',
    'update-params'
])

const onFilterChange = () => {
    emit('change', params.value)
}

const onDateChange = data => {
    params.value.from = data?.[0] || ''
    params.value.to = data?.[1] || ''

    onFilterChange()
}

const clear = () => {
    params.value = {
        from: '',
        to: '',
    }
    period.value = []
    emit('clear', params.value)
}

onBeforeMount (() => {
    for (const key in props.initialParams) {
        if (params.value.hasOwnProperty(key)) {
            params.value[key] = props.initialParams[key]
        }
    }

    period.value = [params.value.from, params.value.to]
})

defineExpose({
    clear
})
</script>

<style lang="scss">

</style>
